import { delayPromise } from '~commonInfra/utils/Delay';

import { callViaApiService as createTags, CatalogContentTypesOnWhichTagsCanBeAdded } from './restApi/catalogContentTags/createCatalogContentTags';
import { callViaApiService as deleteTags, CatalogContentTypesOnWhichTagsCanBeDeleted } from './restApi/catalogContentTags/deleteCatalogContentTags';

export type ChangeTagsOnCatalogContentParams = {
  luids: ReadonlyArray<string>;
  contentType: CatalogContentTypesOnWhichTagsCanBeAdded & CatalogContentTypesOnWhichTagsCanBeDeleted;
  tagsToAdd: ReadonlyArray<string>;
  tagsToRemove: ReadonlyArray<string>;
}

/**
 * Helper function to change tags on catalog content using the REST APIs.
 * Errors are not handled by this function, because the errors displayed will be different
 * depending on the content type.
 *
 * As with the other REST APIs, this function's promise will get rejected with a RestApiErrorResponse
 * if there is a problem.
 */
export async function changeTagsOnCatalogContent(params: ChangeTagsOnCatalogContentParams): Promise<void> {
    const { luids, contentType, tagsToAdd, tagsToRemove } = params;

  if (tagsToRemove.length < 1 && tagsToAdd.length < 1) {
    return;
  }

  if (tagsToRemove.length > 0) {
    await deleteTags({ itemLuids: luids, contentType, tagsToRemove });
  }
  if (tagsToAdd.length > 0) {
    await createTags({ itemLuids: luids, contentType, tagsToAdd });
  }

  // Stall so the data can maybe have a chance to propagate to the metadata service
  await delayPromise(2000);
}
